export default __webpack_public_path__ + "static/media/BCA40.79f2bb54.jpg";